module.exports = __webpack_public_path__ + "img/destinations-north-america.89dafa4e.webp";